import Vue from "vue";
import VueRouter from "vue-router";
import { jwtDecode } from "jwt-decode";

Vue.use(VueRouter);

const routeModules = require.context("./groups", true, /routes\.js$/);
const routes = [];

routeModules.keys().forEach((fileName) => {
  const routeModule = routeModules(fileName).default;
  routes.push(...routeModule);
});

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  // Ambil token dari query parameter
  const token = to.query.token;
  const username = to.query.name;
  const exam = to.query.exam;

  const userData = localStorage.getItem("userData");
  let userLevel = null;

  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      const now = Math.floor(Date.now() / 1000);
      if (decodedToken.exp && decodedToken.exp > now) {
        const userData = {
          nama: username,
          token: token,
          exam: exam,
        };
        localStorage.setItem("userData", JSON.stringify(userData));

        userLevel = decodedToken.role;

        const lastRoute = localStorage.getItem("lastRoute") || "/exam";
        localStorage.removeItem("lastRoute");
        return next(lastRoute);
      }
    } catch (err) {
      console.error("Invalid token from query:", err);
    }
  }

  if (userData) {
    const userAccess = JSON.parse(userData);
    try {
      const decodedToken = jwtDecode(userAccess.token);
      const now = Math.floor(Date.now() / 1000);
      if (decodedToken.exp && decodedToken.exp > now) {
        userLevel = decodedToken.role;
      } else {
        localStorage.removeItem("userData");
        return next("/home");
      }
    } catch (err) {
      console.error("Invalid token:", err);
      localStorage.removeItem("userData");
      return next("/home");
    }
  }

  const requiredLevel = to.meta.requiredLevel;

  if (to.path !== "/home" && !userData) {
    localStorage.setItem("lastRoute", to.fullPath);
    next("/home");
  } else if (to.path === "/home" && userData) {
    const lastRoute = localStorage.getItem("lastRoute") || "/exam";
    localStorage.removeItem("lastRoute");
    next(lastRoute);
  } else if (
    requiredLevel &&
    ![].concat(requiredLevel).some((role) => userLevel.includes(role))
  ) {
    next("/forbidden");
  } else {
    next();
  }
});

export default router;
